import React, { ReactNode } from "react"
import { ErrorObject } from "ajv"
import { Errors } from "../Errors/Errors"
import { Text, FieldLabel } from "dash-styled"
import upperFirst from "lodash/upperFirst"

export interface LabeledProps {
    id?: string
    label?: string
    description?: any
    hideLabel?: boolean
    hideDescription?: boolean
    children: ReactNode
    errors: ErrorObject[]
    testId?: string
    className?: string
}

export const Labeled = ({
    id,
    className,
    children,
    label,
    hideLabel,
    hideDescription,
    errors,
    description,
    testId
}: LabeledProps) => {
    const renderLabel = () => {
        if (hideLabel === true || !label) return null

        return (
            <FieldLabel
                className="mb-1"
                label={upperFirst(label.replace(/_/g, " "))}
            />
        )
    }

    const renderDescription = () => {
        if (hideDescription || description === undefined) return null

        return (
            <Text size="sm" color="gray">
                {description}
            </Text>
        )
    }

    return (
        <label htmlFor={id} data-testid={testId} className={className}>
            {renderLabel()}
            {renderDescription()}
            {children}
            {errors.length > 0 && <Errors errors={errors} />}
        </label>
    )
}
